module.exports = {
  get: require('lodash/get'),
  map: require('lodash/map'),
  isEmpty: require('lodash/isEmpty'),
  chain: require('lodash/chain'),
  cloneDeep: require('lodash/cloneDeep'),
  filter: require('lodash/filter'),
  forEach: require('lodash/forEach'),
  find: require('lodash/find'),
  pick: require('lodash/pick'),
  set: require('lodash/set'),
  compact: require('lodash/compact'),
  assign: require('lodash/assign'),
  reduce: require('lodash/reduce'),
  includes: require('lodash/includes'),
  concat: require('lodash/concat'),
  first: require('lodash/first'),
  merge: require('lodash/merge'),
  isEqual: require('lodash/isEqual'),
  flattenDeep: require('lodash/flattenDeep'),
  keys: require('lodash/keys'),
  head: require('lodash/head'),
  flow: require('lodash/flow'),
  every: require('lodash/every'),
  templateSettings: require('lodash/templateSettings'),
  template: require('lodash/template'),
  omitBy: require('lodash/omitBy')
}
